
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 4.309a9.847 9.847 0 0 1-2.828.775 4.938 4.938 0 0 0 2.165-2.724 9.861 9.861 0 0 1-3.127 1.195 4.924 4.924 0 0 0-8.39 4.491A13.98 13.98 0 0 1 1.67 2.9a4.902 4.902 0 0 0-.666 2.476c0 1.708.87 3.215 2.19 4.098a4.904 4.904 0 0 1-2.23-.616v.062a4.927 4.927 0 0 0 3.95 4.828 4.93 4.93 0 0 1-2.224.085 4.929 4.929 0 0 0 4.6 3.42 9.88 9.88 0 0 1-6.115 2.107c-.398 0-.79-.023-1.175-.069a13.936 13.936 0 0 0 7.548 2.212c9.057 0 14.01-7.503 14.01-14.01 0-.213-.005-.425-.015-.636A10.007 10.007 0 0 0 24 4.308Z","fill":"#55ACEE"}})])
          )
        }
      }
    